import { css } from "@emotion/react";
import { FormInputSubmitField } from "../../wsui/form";
import { Formik, Form } from "formik";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchBox } from "react-instantsearch-hooks";

import {
  generateUniqueId,
  IconButton,
  withDefaultProps,
} from "../../wsui/base";

export default function SearchBox(props) {
  let {
    id,
    label,
    submitLabel,
    placeholder,
    // eslint-disable-next-line no-unused-vars
    searchAsYouType,
    name = "query",
    ...restProps
  } = props;
  const { t } = useTranslation();
  const {
    query,
    refine,
    clear,
    // isSearchStalled,
  } = useSearchBox(props);

  const [defaultId] = useState(() => `search-box-${generateUniqueId()}`);

  label = label || t(["wsui.algolia.searchBoxLabel"]);
  submitLabel = submitLabel || t(["wsui.algolia.searchBoxSubmitLabel"]);
  id = id || defaultId;

  // const submitButtonIcon = useMemo(
  //   () => <Icon name="search" size="1.125em" />,
  //   [],
  // );

  return (
    <Formik
      initialValues={{ [name]: query || "" }}
      onSubmit={async ({ [name]: query }) => {
        refine(query);
      }}
      onReset={async () => {
        clear();
      }}
    >
      {() => (
        <Form
          css={css`
            position: relative;
          `}
        >
          <FormInputSubmitField
            label={label}
            hideLabel
            id={id}
            name={name}
            placeholder={
              placeholder || t(["wsui.algolia.searchBoxPlaceholder"])
            }
            css={css`
              --form-input-width: var(--search-form-input-width, 100%);
              --form-input-padding: var(--search-form-padding-default, 1rem);
              --form-input-border: var(--search-form-border, none);
              --form-input-border-radius: var(
                --search-form-border-radius,
                0.25rem
              );
              --form-input-background: var(--search-form-background, #ffffff);
              --form-input-font-family: var(--search-form-font-family, inherit);
              --form-input-font-size: var(--search-form-font-size, 100%);
              --form-input-color: var(--search-form-surface, #000000);
            `}
            components={{
              InputWrapper: {
                style: {
                  fontSize: [4, 6],
                },
              },
              SubmitButton: withDefaultProps(IconButton, {
                label: submitLabel,
                icon: "search",
                size: "1.125em",
                color: "white",
                style: {
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                },
              }),
            }}
            {...restProps}
          />
        </Form>
      )}
    </Formik>
  );
}
